// Escuela Metta — central data: images, WhatsApp config, bilingual content

export const WHATSAPP_NUMBER = "34633153726";

export const WA_MESSAGE = {
  es: "Hola ✨ he llegado hasta vuestra Formación de Terapeuta en Activación Kundalini y siento que puede resonar conmigo.\n\nMe gustaría descubrir más sobre la formación y entender si este camino encaja con mi momento y mi evolución personal/profesional.\n\n¿Cuál sería el siguiente paso para conocerla por dentro? 🤍",
  en: "Hello ✨ I've found your Kundalini Activation Therapist Training and I feel it may resonate with me.\n\nI'd love to discover more about the training and understand if this path fits my current moment and my personal/professional evolution.\n\nWhat would be the next step to get to know it from the inside? 🤍",
};

export const waUrl = (lang = "es") =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WA_MESSAGE[lang] || WA_MESSAGE.es)}`;

const U = (id, w = 1600) =>
  `https://images.unsplash.com/photo-${id}?crop=entropy&cs=srgb&fm=jpg&q=80&w=${w}`;

export const images = {
  hero: "https://customer-assets.emergentagent.com/job_mettasomatic-pro/artifacts/q16qi9my__DOSSIER%20ACTIVACION%20KUNDALINI%20TERAPEUTA%20CERTIFICADO%20METTA%202026%20%281%29.png",
  videoThumb: U("1554244933-d876deb6b2ff", 2000),
  band: "https://customer-assets.emergentagent.com/job_mettasomatic-pro/artifacts/jor42cwh_Dise%C3%B1o%20sin%20t%C3%ADtulo%20%2862%29.png",
  pain: "https://customer-assets.emergentagent.com/job_mettasomatic-pro/artifacts/ei2ef4vv_Sin%20t%C3%ADtulo%20%281200%20x%201500%20px%29.jpg",
  trained: U("1709316010508-6c86856540e4"),
  bridge: "https://images.pexels.com/photos/20219049/pexels-photo-20219049.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200",
  about: "https://customer-assets.emergentagent.com/job_mettasomatic-pro/artifacts/12zm99yr_Mallorca%20-1015%20%282%29.jpg",
  closing: U("1765520890144-e4c10255dcc4", 2000),
  reels: [
    "https://customer-assets.emergentagent.com/job_mettasomatic-pro/artifacts/xymtfs8q_formaicon%20activacion%20kundalini%20escuela%20metta%20kap%20susana%20dakini.webp",
    "https://customer-assets.emergentagent.com/job_mettasomatic-pro/artifacts/8eig5gow_curso%20activacion%20kundalini%20innerdance%20susana%20dakini%20escuela%20metta.webp",
    "https://customer-assets.emergentagent.com/job_mettasomatic-pro/artifacts/zcecdper_activar%20kundalini%20escuela%20metta%20susana%20dakini.webp",
    "https://customer-assets.emergentagent.com/job_mettasomatic-pro/artifacts/8igpgj1p_curso%20activacion%20kundalimi%20metta%20innerdance%20susana%20dakini.webp",
    "https://customer-assets.emergentagent.com/job_mettasomatic-pro/artifacts/9833px8y_IMG_3989.webp",
  ],
  testimonials: [
    U("1709316010508-6c86856540e4", 800),
    "https://images.pexels.com/photos/6135091/pexels-photo-6135091.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=800",
    U("1637297661859-1d77077828ff", 800),
    U("1506863530036-1efeddceb993", 800),
    U("1507003211169-0a1dd7228f2d", 800),
    U("1690846152581-37a78f2e83e9", 800),
    U("1609371497456-3a55a205d5eb", 800),
    "https://images.pexels.com/photos/4625044/pexels-photo-4625044.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=800",
    U("1499568509606-4f9b771232ed", 800),
    "https://images.pexels.com/photos/6135083/pexels-photo-6135083.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=800",
    U("1634517031809-b7326e83013e", 800),
    "https://images.pexels.com/photos/6648583/pexels-photo-6648583.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=800",
  ],
};

const es = {
  langName: "ES",
  nav: {
    links: [
      { id: "metodo", label: "El Método" },
      { id: "aprender", label: "Qué aprenderás" },
      { id: "susana", label: "Quiénes somos" },
      { id: "inversion", label: "Inversión" },
      { id: "ediciones", label: "Ediciones" },
      { id: "testimonios", label: "Testimonios" },
      { id: "faq", label: "FAQ" },
    ],
    cta: "Quiero optar a una plaza",
  },
  ctas: {
    info: "Solicitar información",
    call: "Agendar llamada de admisión",
    discover: "Descubre si esta formación es para ti",
    talk: "Hablar con Escuela Metta",
  },
  sticky: "Agendar llamada de admisión",
  hero: {
    badge: "Formación profesional en Activación Kundalini METTA®",
    title: "Aprende a guiar el despertar de la energía Kundalini de forma segura.",
    subtitle:
      "Conviértete en Terapeuta Certificado con el único método que une ciencia y espiritualidad para comprender qué ocurre realmente durante un despertar de Kundalini y acompañar procesos profundos con seguridad, confianza y criterio profesional.",
    bullets: [
      "Vive primero tu propia transformación.",
      "Aprende una metodología que da resultados.",
      "Crea sesiones individuales y grupales de alto valor.",
      "Convierte tu don en tu profesión.",
      "Vence el síndrome del impostor y la procrastinación.",
    ],
    cta: "Reservar entrevista",
  },
  video: {
    overline: "Un mensaje de la fundadora",
    title: "El vídeo que ojalá hubiera visto antes de formarme",
    videoId: "1206521365",
    thumb: "https://customer-assets.emergentagent.com/job_mettasomatic-pro/artifacts/9h1ze9bc_Dise%C3%B1o%20sin%20t%C3%ADtulo%20%2859%29.png",
    subtitle:
      "Lo que ninguna escuela me explicó sobre cómo guiar despertares de Kundalini de forma segura.",
    discoverTitle: "Cuando termines esta formación:",
    discover: [
      "Saldrás preparado para facilitar sesiones individuales y grupales con seguridad y confianza desde el primer día.",
      "Aprenderás a sostener procesos profundos de transformación sin improvisar ni absorber el dolor de las personas que acompañas.",
      "Dominarás protocolos claros para saber qué herramienta utilizar en cada momento según las necesidades de cada cliente.",
      "Aprenderás a crear playlists profesionales de Activación Kundalini y comprenderás cómo utilizar la música para guiar cada fase de una sesión.",
      "Accederás a la biblioteca exclusiva de playlists de Susana Dakini y aprenderás a utilizar instrumentos chamánicos para potenciar la experiencia terapéutica.",
      "Recibirás acompañamiento para construir tu marca personal, atraer a tus primeros clientes y convertir tu vocación en una profesión.",
      "Formarás parte de una comunidad internacional de facilitadores que seguirá apoyándote y acompañando tu crecimiento profesional tras la certificación.",
    ],
    discoverClose:
      "No solo aprenderás una técnica. Saldrás con un sistema completo: protocolos, playlists, instrumentos, recursos y una metodología lista para acompañar transformaciones profundas desde el primer día.",
    caption: "Susana Dakini, fundadora y formadora de Kundalini Metta",
    play: "Reproducir mensaje",
    placeholder: "Vídeo de Susana Dakini — listo para insertar (YouTube / Vimeo / MP4)",
  },
  pain: {
    overline: "El llamado",
    title:
      "Te hicieron creer que tu sensibilidad y conexión espiritual eran el problema. Lo único que necesitabas era un método que transformara tu intuición en criterio profesional.",
    points: [
      "Sabes que tienes una sensibilidad especial. Percibes cosas que otras personas no perciben. Pero todavía no sabes cómo convertir ese don en una herramienta terapéutica segura y profesional.",
      "Llevas años formándote. Has hecho cursos, leído libros y vivido experiencias profundas. Aun así, sientes que todavía te falta «algo» para acompañar a otras personas con verdadera confianza.",
      "Ves a otros terapeutas guiando sesiones, creando grupos y viviendo de aquello que aman. Y en el fondo piensas: «Yo también sé que podría hacerlo».",
      "Pero entonces aparece el síndrome del impostor: «¿Y si no sé qué hacer durante una sesión?», «¿Y si no ocurre nada?», «¿Y si ocurre demasiado?», «¿Y si hago daño?», «¿Y si todavía no soy suficiente?».",
      "No dudas de tu vocación. Dudas de no haber encontrado todavía el método que te enseñe a guiar despertares de Kundalini de forma segura, comprender cada proceso y sentirte preparada para transformar vidas con confianza.",
    ],
    quote:
      "Te hicieron creer que tu sensibilidad y conexión espiritual eran el problema. Lo único que necesitabas era un método que transformara tu intuición en criterio profesional.",
  },
  trained: {
    overline: "Para quien ya se ha formado",
    title: "Saber activar energía no te convierte en terapeuta. Comprender lo que ocurre durante un despertar de Kundalini, sí.",
    intro:
      "Has aprendido una técnica. Has facilitado sesiones. Quizá incluso ya acompañas personas. Pero, en el fondo, todavía hay momentos en los que te preguntas…",
    tags: ["Activación Kundalini", "Innerdance", "Shaktipat", "Terapias energéticas"],
    questions: [
      {
        scenario: "La persona empieza a temblar…",
        question:
          "¿Cómo sabes si es una descarga del sistema nervioso, una liberación emocional o un proceso de despertar de Kundalini?",
      },
      {
        scenario: "El cliente rompe a llorar.",
        question: "¿Intervienes… o dejas que el proceso continúe?",
      },
      {
        scenario: "Después de la sesión todo parece haber cambiado…",
        question:
          "¿Cómo consigues que esa transformación no desaparezca tres días después?",
        note: "Aquí es donde entra la integración.",
      },
      {
        scenario: "Tu cliente te pregunta: «¿Qué me acaba de pasar?»",
        question:
          "¿Serías capaz de explicárselo desde la ciencia… y también desde la conciencia?",
      },
    ],
    quote: {
      lead: "Cuando no comprendes lo que está ocurriendo…",
      lines: [
        "Improvisas.",
        "Dudas.",
        "Pierdes confianza.",
        "Tus clientes lo perciben.",
        "Y acabas dependiendo de la intuición en lugar de un método, y te sientes perdido en medio de la sesión porque no sabes cómo unir intuición y método.",
      ],
      close:
        "No porque seas un mal terapeuta. Sino porque nadie te enseñó a interpretar lo que ocurre durante un verdadero despertar de Kundalini.",
    },
  },
  bridge: {
    overline: "El error que cometen casi todas las escuelas",
    title:
      "La calidad de un terapeuta no se mide por la intensidad de la experiencia que provoca.",
    subtitle:
      "Se mide por su capacidad para sostener, integrar y consolidar una transformación que permanece mucho después de que la sesión termina.",
    paragraphs: [
      "La mayoría de escuelas ponen toda su atención en provocar una experiencia.",
      "Y la verdad es que la calidad se mide por los resultados que sus clientes consiguen semanas y meses después de las sesiones.",
      "Nosotros ponemos nuestra atención en conseguir que esa experiencia transforme una vida.",
      "Porque una experiencia intensa puede emocionar durante unas horas. Incluso durante unos días. Pero si el terapeuta no sabe integrarla… la persona volverá a pensar igual, a sentir igual y a repetir los mismos patrones que llevaba años intentando cambiar.",
      "Por eso, en KUNDALINI METTA®, no solo aprenderás a guiar despertares de Kundalini de forma segura. Aprenderás la parte más importante de todo el proceso: cómo convertir una experiencia en una transformación permanente.",
    ],
    midHeading: "Aquí es donde nace un verdadero terapeuta.",
    paragraphs2: [
      "Durante la integración es cuando el cerebro crea nuevas conexiones. Cuando el cuerpo deja de reaccionar desde viejos patrones. Cuando las emociones encuentran una nueva forma de expresarse. Cuando las creencias limitantes empiezan a perder fuerza. Y cuando la persona deja de sobrevivir… para empezar a vivir desde un lugar completamente diferente.",
      "Por eso nuestros alumnos no crean sesiones impactantes. Crean procesos que siguen transformando la vida de sus clientes mucho después de que la sesión haya terminado.",
      "Ese es el motivo por el que nuestro método es diferente.",
      "La mayoría de escuelas te enseñan cómo abrir una sesión. Nosotros te enseñamos qué hacer antes, durante y después.",
      "Porque las grandes transformaciones nunca dependen de una experiencia aislada. Dependen de cómo acompañas todo el proceso.",
      "Y ese proceso es el que hace que tus clientes:",
    ],
    bullets: [
      "Vuelvan.",
      "Recomienden tu trabajo.",
      "Confíen más en ti.",
      "Y vivan cambios que realmente permanecen.",
    ],
  },
  method: {
    overline: "",
    title:
      "El sistema que te enseña a guiar despertares de Kundalini de forma segura, profunda e integrativa.",
    intro:
      "No aprenderás solo «qué hacer» en una sesión. Aprenderás a comprender qué está ocurriendo, cómo sostenerlo y cómo integrarlo para que la experiencia no se quede en algo intenso… sino que se convierta en una transformación real.",
    pillars: [
      {
        n: "01",
        title: "Activación Kundalini METTA®",
        desc: [
          "Aprenderás a abrir, sostener y cerrar sesiones individuales y grupales con una estructura clara, segura y profesional.",
          "No se trata de «provocar energía». Se trata de saber guiar un proceso donde la persona pueda reconectar con su cuerpo, su intuición, su esencia y su propósito sin perder seguridad ni dirección.",
        ],
      },
      {
        n: "02",
        title: "Ciencia del despertar",
        desc: [
          "Comprenderás qué ocurre durante una sesión a nivel de sistema nervioso, cuerpo físico, emociones, bioquímica y estados de conciencia.",
          "Porque cuando sabes explicar lo que está pasando, dejas de improvisar. Y empiezas a acompañar con criterio, presencia y confianza profesional.",
        ],
      },
      {
        n: "03",
        title: "Integración de la experiencia",
        desc: [
          "Esta es la parte que más escuelas olvidan.",
          "Una experiencia intensa puede emocionar. Pero una experiencia bien integrada puede cambiar una vida.",
          "Aprenderás a acompañar el después de la sesión para que el cliente pueda convertir lo vivido en claridad, decisiones, liberación de patrones y cambios reales en su vida cotidiana.",
        ],
      },
      {
        n: "04",
        title: "Herramientas de sanación profunda",
        desc: ["La formación incluye técnicas específicas para crear procesos reales de transformación:"],
        items: [
          "Breathwork específico para Activación Kundalini, para preparar el cuerpo y profundizar la experiencia.",
          "Sanación cuántica para cuerpo físico, emocional y espiritual, para trabajar en diferentes capas del proceso.",
          "Liberación de Pericardio Express, para desbloquear el centro del corazón y favorecer apertura emocional.",
          "Reprogramación de creencias limitantes, para sostener la transformación después de la sesión y evitar que la persona vuelva al mismo patrón.",
        ],
      },
      {
        n: "05",
        title: "Facilitación profesional",
        desc: [
          "Aprenderás cómo abrir una sesión, leer el proceso, intervenir cuando sea necesario, sostener momentos profundos y cerrar de forma segura.",
          "También aprenderás a explicar tu trabajo con claridad para que tus clientes comprendan el valor de lo que haces y confíen más en tu acompañamiento.",
        ],
      },
      {
        n: "06",
        title: "Expansión de tu práctica profesional",
        desc: [
          "Si ya eres terapeuta, esta formación no viene a sustituir lo que haces. Viene a elevarlo.",
          "Podrás crear sesiones individuales premium, procesos VIP, sesiones grupales, talleres, retiros y experiencias de alto valor que aumenten la recurrencia de tus clientes y diferencien tu trabajo en un mercado saturado de técnicas.",
        ],
      },
    ],
    closing:
      "No saldrás con una técnica más. Saldrás con un sistema completo para acompañar despertares de Kundalini con seguridad, ciencia, espiritualidad, integración y visión profesional.",
  },
  learn: {
    overline: "Programa",
    title: "Qué aprenderás",
    items: [
      "Activación Kundalini individual y grupal",
      "Sostener el campo energético",
      "Sistema de chakras y meridianos",
      "Neurociencia de la activación",
      "Ondas cerebrales y sonido",
      "Creación de playlist profesional",
      "Breathwork para activar y regular",
      "Liberación de pericardio",
      "Protección energética del terapeuta",
      "Lenguaje de luz y voz",
      "Gestión de sesiones",
      "Marketing para terapeutas",
    ],
  },
  experience: {
    overline: "La experiencia formativa",
    title: "",
    formats: [
      { tag: "Fase 1", label: "Nivel Online", desc: "Aprende autoactivación de la energía Kundalini, desbloqueo de chakras, expansión de la intuición y los fundamentos científicos y energéticos que te prepararán para convertirte en terapeuta." },
      { tag: "Fase 2", label: "4 días de formación presencial intensiva", desc: "Transforma el conocimiento en experiencia. Practica con casos reales, facilita sesiones bajo la supervisión de Susana Dakini y su equipo, recibe feedback personalizado y desarrolla la seguridad, la confianza y las habilidades necesarias para acompañar procesos profundos de transformación con criterio profesional." },
    ],
    note: "Formación certificada · Activación Kundalini Metta",
  },
  testimonials: {
    overline: "",
    title: "Historias reales de transformación",
    subtitle:
      "Antes del miedo. Después del método. Lo que ocurre cuando una experiencia se convierte en una profesión.",
    people: [
      { name: "Almudena", role: "Psicóloga", videoId: "1206449879", thumb: "https://i.vimeocdn.com/video/2175299296-773b1ea0b96444ff0e5923615b87fa0ae89373e32bf477bf45e27e1b93f4372d-d_960" },
      { name: "Cristina", role: "Psicóloga", videoId: "1206448715", thumb: "https://i.vimeocdn.com/video/2175293373-d045084da7e6df3c1a85d0f54d2e671b67a8f5bafb62779458c01878ac6fae09-d_960" },
      { name: "Ruth", role: "Terapeuta", videoId: "1206478560", thumb: "https://i.vimeocdn.com/video/2175335773-f534cfad3d2ba1f6a3d36f730861b21268a869e9ac8aa94dd01b6c4b933de6d2-d_960" },
      { name: "Diana", role: "Terapeuta", videoId: "1206483810", thumb: "https://i.vimeocdn.com/video/2175338297-3eba4de8c82f7ad3f1c2898eaeac6105dda2623edab9350cb084864bd5077833-d_960" },
      { name: "Paula", role: "Ingeniera y Coach", videoId: "1206482585", thumb: "https://i.vimeocdn.com/video/2175337340-8fceb2079c06da2ab65cec4be0777b28003478a85a139463228f6b59f5b2fd36-d_960" },
      { name: "Diana", role: "Profesora de Yoga", videoId: "1206484595", thumb: "https://i.vimeocdn.com/video/2175339256-fae0da030004180bec19a322c28a6b5c372b34176b8437c0b264f7ae19715bab-d_960" },
      { name: "María", role: "Profesora", videoId: "1206485797", thumb: "https://i.vimeocdn.com/video/2175355265-4357885229c65888797d2d034ae93d9d20411be205dc7be67fb3e61496b85cb8-d_960" },
    ],
  },
  about: {
    overline: "Sobre mí",
    name: "Susana Dakini",
    role: "Fundadora de Escuela Metta",
    quote:
      "Nunca podrás construir una vida más abundante que el nivel de merecimiento que tu propio sistema nervioso es capaz de sostener.",
    bio1: [
      "Después de experimentar varios despertares de Kundalini espontáneos, decidí formarme con Pi Villaraza y otros maestros.",
      "No lo aprendí en un libro ni en un máster. Lo aprendí intentando reconstruir mi propia vida.",
      "Mi historia comenzó siendo una niña. Pasé meses ingresada en hospitales por graves problemas respiratorios y llegué a sufrir tres paradas cardiorrespiratorias. Poco después viví nueve años de bullying. Sin saberlo, mi sistema nervioso aprendió demasiado pronto a vivir en modo supervivencia.",
      "Con el tiempo llegaron la ansiedad, los ataques de pánico y una pregunta que cambiaría mi destino:",
    ],
    midQuote:
      "¿Por qué, si mi mente sabía que estaba a salvo, mi cuerpo seguía reaccionando como si el peligro nunca hubiera terminado?",
    bio2: [
      "Buscando respuestas estudié Farmacia. Quería comprender el cuerpo humano y aliviar el sufrimiento. Pero pronto entendí que estaba aprendiendo a tratar enfermedades… sin comprender realmente a la persona que había detrás de ellas.",
      "Tomé entonces una decisión que transformó mi vida: dejar ese camino para dedicarme a investigar la conexión entre ciencia, cuerpo y conciencia.",
      "Durante los últimos 15 años he invertido más de 60.000 € en formación, especializándome en trauma, neurociencia, Breathwork, Mindfulness, Psicología Transpersonal, regulación del sistema nervioso y estados expandidos de conciencia, con un único propósito: comprender cómo ocurre una transformación profunda y duradera.",
      "Ese viaje dio origen a Escuela Metta y al desarrollo de tres metodologías propias que hoy han formado a cientos de terapeutas y facilitadores, integrando ciencia, respiración, trauma, trabajo somático y conciencia en un mismo camino de transformación.",
    ],
    methods: [
      { name: "METTABREATH®", desc: "para la formación de instructores de Breathwork, regulación del sistema nervioso y transformación profunda." },
      { name: "KUNDALINI METTA®", desc: "mi metodología de Activación Kundalini desde una perspectiva neurofisiológica, somática y trauma informado, donde la energía se comprende y acompaña desde la integración entre ciencia y conciencia." },
      { name: "SOMAFLOW®", desc: "un método de liberación somática del trauma que integra el trabajo corporal, el sistema fascial, la regulación del sistema nervioso y las principales corrientes internacionales de terapia somática." },
    ],
    bio3: [
      "Desde 2012 he tenido el privilegio de formar a más de 600 terapeutas y facilitadores, y acompañar a miles de personas en algunos de los momentos más importantes de sus vidas.",
      "Pero mi mayor logro nunca han sido las certificaciones ni el número de alumnos. Es ver cómo personas que un día llegaron sintiéndose rotas descubren que sus heridas pueden convertirse en el lugar desde el que mejor acompañan a los demás.",
      "Porque esa ha sido también mi historia. Y esa sigue siendo la esencia de METTABREATH®.",
    ],
    mission:
      "No formar únicamente instructores de Breathwork. Formar terapeutas y facilitadores cuya propia transformación se convierte en la mayor herramienta con la que acompañarán la transformación de los demás.",
    missionClose:
      "Hoy mi misión es formar a una nueva generación de profesionales que no solo dominen una técnica, sino que se conviertan en el lugar seguro desde el que otras personas puedan transformar su vida.",
    stats: [
      { n: "2012", l: "desde" },
      { n: "+600", l: "alumnos certificados" },
      { n: "+3500", l: "sesiones facilitadas" },
    ],
    creatorLabel: "Creadora de",
    creator: ["METTABREATH®", "KUNDALINI METTA®", "SOMAFLOW®"],
    formationsLabel: "Formación en",
    formations: ["Trauma", "Neurociencia", "Breathwork", "Mindfulness", "Psicología Transpersonal", "Somática", "Estados expandidos"],
  },
  faculty: {
    overline: "Equipo docente",
    title: "Junto a Susana Dakini y Viveka Romero",
    subtitle:
      "Una formación acompañada por un equipo multidisciplinar de maestros y especialistas.",
    people: [
      { name: "Viveka Romero", role: "Formador Escuela Metta, profesor de meditación Non Duality y escritor.", img: "/teachers/viveka.jpg" },
      { name: "Raúl Bautista", role: "Productor musical y DJ, formador de creación de playlist y sonido.", img: "/teachers/raul.jpg" },
      { name: "Damaris Sánchez", role: "Profesora fonoenergética y tambor chamánico, canto y activación de sonido y energía.", img: "/teachers/damaris.jpg" },
      { name: "Rebeca Muru", role: "Formadora Somaflow, especialista en trauma y yoga somático.", img: "/teachers/rebeca.jpg" },
    ],
  },
  bonus: {
    overline: "Incluido en la formación",
    title: "Además recibes",
    items: [
      { t: "Holistic Business Plan", d: "Aprende a crear tu primer embudo de ventas, atraer tus primeros clientes y convertir tu pasión en una profesión con una estrategia clara y sostenible." },
      { t: "Sesión de fotos y vídeos", d: "Obtén contenido exclusivo para tus redes sociales, web y marca personal desde el primer día." },
      { t: "Creación de playlists profesionales", d: "Aprende a diseñar playlists que potencien cada fase de la sesión y recibe la biblioteca exclusiva de playlists de Susana Dakini, listas para utilizar desde tu primera sesión." },
      { t: "Apoyo de marca Escuela Metta", d: "Incluimos Directorio Oficial de Terapeutas, promoción en redes sociales, 1 año de Spiritual Mastery y acceso a una comunidad exclusiva para seguir creciendo." },
      { t: "Comunidad privada de alumnos", d: "Practica con otros compañeros, comparte experiencias y resuelve dudas en nuestro grupo privado de WhatsApp. Porque crecer acompañado siempre acelera tu evolución como terapeuta." },
      { t: "Repetición de la formación 2 años", d: "Vuelve a vivirla siempre que lo necesites." },
      { t: "Tecnología BioWell", d: "Análisis energético y medición real." },
    ],
  },
  editions: {
    overline: "Calendario de ediciones 2026",
    title: "Próximas ediciones",
    subtitle:
      "3 meses de formación online + 4 días presenciales. Elige la ciudad a la que quieres asistir. Grupos reducidos: las plazas se asignan tras la entrevista de valoración.",
    note: "* Cada edición combina 3 meses online con 4 días presenciales (retiro en el caso señalado).",
    cta: "Reservar mi plaza",
    list: [
      {
        date: "Julio 2026",
        name: "Retiro presencial · 21–26",
        location: "Guadalajara · España",
        format: "Online + retiro presencial",
        status: "Completado",
        tone: "done",
      },
      {
        date: "Septiembre 2026",
        name: "Presencial · 24–27",
        location: "Barcelona · España",
        format: "3 meses online + 4 días presenciales",
        status: "Últimas plazas",
        tone: "few",
      },
      {
        date: "Octubre 2026",
        name: "Presencial · 8–11",
        location: "Madrid · España",
        format: "3 meses online + 4 días presenciales",
        status: "Inscripción abierta",
        tone: "open",
      },
      {
        date: "Noviembre 2026",
        name: "Presencial · 19–22",
        location: "Mallorca · España",
        format: "3 meses online + 4 días presenciales",
        status: "Inscripción abierta",
        tone: "open",
      },
      {
        date: "Diciembre 2026",
        name: "Presencial · 3–6",
        location: "Málaga · España",
        format: "3 meses online + 4 días presenciales",
        status: "Inscripción abierta",
        tone: "open",
      },
    ],
  },
  pricing: {
    overline: "Inversión y reserva de plaza",
    title: "Tu transformación como terapeuta comienza con una decisión.",
    intro: [
      "Estás invirtiendo en una metodología que podrás utilizar durante toda tu vida profesional para guiar despertares de Kundalini de forma segura, crear procesos completos de transformación y construir un negocio basado en el impacto real que generas en tus clientes.",
    ],
    consequences: ["Cada sesión.", "Cada proceso VIP.", "Cada experiencia grupal.", "Cada retiro.", "Cada recomendación."],
    consequencesNote:
      "Será una consecuencia directa de las habilidades que desarrollarás durante esta certificación.",
    plansLabel: "Elige cómo incorporarte",
    plans: [
      {
        name: "Formación + Mentoría VIP",
        price: "2.490 €",
        featured: false,
        desc: "El nivel más completo y exclusivo: acompañamiento personal y directo de Susana Dakini para acelerar tu camino como terapeuta.",
        pointsLabel: "Incluye",
        points: [
          "9 sesiones de mentoría individual con Susana Dakini para acompañarte personalmente en tu evolución como terapeuta y ayudarte a integrar todo lo aprendido.",
          "1 sesión presencial de sanación con Susana Dakini, diseñada para profundizar en tu propio proceso antes de acompañar el de otras personas.",
          "Seguimiento durante 12 meses, para que nunca te sientas solo al comenzar a facilitar tus primeras sesiones.",
          "Auditoría personalizada de tu negocio, donde revisaremos tu estrategia para ayudarte a convertir tu pasión en una profesión rentable.",
          "Diseño de tu página web profesional como terapeuta de Activación Kundalini, lista para comenzar a captar clientes.",
          "Dispositivo de protección energética exclusivo de Escuela Metta para acompañarte durante tus sesiones con mayor seguridad y confianza.",
          "🎁 De regalo: Diapasón Terapéutico Profesional de 128 Hz, una herramienta de terapia vibracional para enriquecer tus sesiones y ampliar tus recursos como terapeuta.",
          "🎁 De regalo: Kit de aceite esencial de conexión y enraizamiento.",
          "Soporte prioritario, con atención preferente para resolver tus dudas y acompañarte siempre que lo necesites.",
        ],
        cta: "Quiero reservar mi entrevista",
      },
      {
        name: "Acceso Preferente",
        badge: "Recomendado",
        seal: "Plazas limitadas",
        price: "1.222 €",
        priceNote: "Solo por 72 horas",
        featured: true,
        desc: "La forma más inteligente de incorporarte a la Certificación KUNDALINI METTA®.",
        points: [
          "Reserva hoy tu plaza con solo 111 €.",
          "Tu acceso preferente permanecerá activo durante las próximas 72 horas.",
          "El resto (1.111 €) podrás pagarlo en un único pago o dividirlo en hasta 4 cuotas sin intereses.",
          "Una vez transcurridas esas 72 horas, esta modalidad dejará de estar disponible.",
        ],
        cta: "Quiero reservar mi entrevista",
      },
      {
        name: "Acceso Flexible",
        price: "1.490 €",
        featured: false,
        desc: "Para quienes prefieren distribuir la inversión en varios pagos y comenzar ahora su formación.",
        pointsLabel: "Opciones de financiación",
        points: [
          "3 cuotas de 496 €",
          "6 cuotas de 259 €",
          "8 cuotas de 196 €",
        ],
        cta: "Quiero reservar mi entrevista",
      },
    ],
    whyTitle: "¿Por qué mantenemos esta ventana de acceso durante solo 72 horas?",
    why: [
      "Porque no buscamos a las personas que pasan meses dudando.",
      "Buscamos a quienes sienten el llamado, toman una decisión y se comprometen con convertirse en el terapeuta que saben que pueden llegar a ser.",
      "No es una promoción. Es una forma de premiar el compromiso y facilitar el acceso a quienes están preparados para dar el siguiente paso.",
      "Lo verdaderamente importante no es cuánto cuesta esta formación. Es todo lo que serás capaz de generar gracias a ella.",
    ],
    benefits: [
      "Una metodología que utilizarás durante toda tu carrera profesional.",
      "La capacidad de crear sesiones individuales premium y procesos VIP.",
      "La posibilidad de facilitar experiencias grupales y retiros de alto valor.",
      "Clientes que regresan porque viven transformaciones reales.",
      "Recomendaciones constantes gracias al impacto de tu trabajo.",
      "Una profesión alineada con tu propósito y un negocio construido sobre resultados, no sobre promesas.",
    ],
    closing:
      "La verdadera pregunta no es si puedes permitirte esta formación. La verdadera pregunta es cuánto tiempo más quieres seguir sin convertirte en el terapeuta que sabes que puedes llegar a ser.",
    closingCta: "Quiero reservar mi entrevista",
  },
  mbPricing: {
    overline: "Inversión",
    title: "Elige cómo quieres acceder a la Certificación Internacional METTABREATH®",
    subtitle1:
      "Todas las opciones incluyen exactamente la misma formación, la misma certificación oficial METTABREATH®, el acceso completo al campus, la comunidad privada y todo el acompañamiento durante tu proceso.",
    subtitle2: "La única diferencia está en cómo decides realizar tu inversión.",
    plans: [
      {
        tone: "elite",
        badge: "Experiencia Elite",
        name: "Inner Circle METTABREATH®",
        price: "2.490€",
        desc: "La experiencia más exclusiva para quienes desean un acompañamiento totalmente personalizado para acelerar su desarrollo profesional.",
        points: [
          "Acceso completo a la Certificación Internacional METTABREATH®",
          "Mentoría privada 1:1 con Susana Dakini",
          "Revisión personalizada de tus primeras sesiones",
          "Feedback individual sobre tu evolución como instructor",
          "Soporte prioritario",
          "Estrategia personalizada para lanzar tus primeras experiencias METTABREATH®",
        ],
        cta: "Quiero formar parte del Inner Circle",
        featured: false,
      },
      {
        tone: "star",
        badge: "La opción más elegida",
        name: "Acceso Preferente",
        price: "1.490€",
        desc: "La mejor relación entre inversión y valor.",
        points: [
          "Acceso completo a la Certificación Internacional METTABREATH®",
          "Reserva hoy tu plaza con solo 199€",
          "Los 199€ se descuentan íntegramente del precio final",
          "Ahorras 300€ respecto al Acceso Flexible",
          "Mantienes este precio especial durante las próximas 72 horas",
          "Exactamente la misma formación, certificación y acompañamiento",
        ],
        cta: "Quiero asegurar mi plaza",
        featured: true,
      },
      {
        tone: "flex",
        badge: "Acceso Flexible",
        name: "Pago Fraccionado",
        price: "1.790€",
        desc: "La misma certificación. Más flexibilidad para realizar tu inversión.",
        text: "Reserva hoy tu plaza con solo 199€ y elige cómo prefieres completar el resto de tu inversión.",
        installments: [
          { n: "3 cuotas", amount: "530€/mes" },
          { n: "6 cuotas", amount: "265€/mes" },
          { n: "8 cuotas", amount: "199€/mes" },
        ],
        cta: "Quiero acceder con pago flexible",
        featured: false,
      },
    ],
    mostTitle: "¿Cuál eligen la mayoría de nuestros alumnos?",
    most: [
      "Si puedes realizar el pago único, Acceso Preferente es la opción que ofrece el mayor valor.",
      "Obtienes exactamente la misma certificación, el mismo acompañamiento y todos los beneficios del programa, ahorrando 300€ respecto al Acceso Flexible.",
      "Por eso es la modalidad elegida por la gran mayoría de nuestros alumnos.",
    ],
    guarantee: [
      "Misma certificación oficial",
      "Mismo contenido",
      "Mismos bonus",
      "Mismo acompañamiento",
      "Misma comunidad",
      "Misma experiencia de transformación",
    ],
    guaranteeNote: "La única diferencia es la forma en la que decides realizar tu inversión.",
  },
  application: {
    overline: "El siguiente paso",
    title: "¿Sientes que este es tu siguiente paso?",
    text:
      "No buscamos formar facilitadores que solo repitan una técnica. Formamos terapeutas capaces de comprender, sostener y acompañar procesos reales de transformación.",
    cta: "Agendar llamada con Escuela Metta",
  },
  faq: {
    overline: "Dudas frecuentes",
    title: "Preguntas frecuentes",
    items: [
      { q: "¿Necesito experiencia previa?", a: "No. No necesitas tener experiencia como terapeuta ni haber realizado otras formaciones para acceder a la certificación.\n\nEl programa está diseñado para acompañarte paso a paso, construyendo desde la base una comprensión sólida del sistema nervioso, la neurofisiología, la energía, la respiración y la facilitación de procesos de transformación, para que puedas avanzar con seguridad y confianza.\n\nAl mismo tiempo, si ya eres terapeuta, coach, profesor de yoga, profesional de la salud o acompañas personas en otros ámbitos, aprenderás a integrar esta metodología en tu práctica profesional, ampliando tus recursos y elevando la calidad de tus acompañamientos.\n\nNo importa desde dónde empieces. Lo importante es que, al finalizar la certificación, tengas los conocimientos, la práctica y la confianza necesarios para facilitar sesiones con criterio, seguridad y profesionalidad." },
      { q: "¿Puedo formarme si ya he estudiado en otra escuela?", a: "Sí. De hecho, muchos de nuestros alumnos llegan después de haberse formado en otras metodologías.\n\nCada escuela aporta una visión diferente, y esa experiencia previa suele convertirse en una gran ventaja durante la certificación.\n\nEn Escuela Metta profundizarás en la comprensión del sistema nervioso, la neurofisiología, la integración emocional y la energía, para entender con mayor claridad qué sucede durante una sesión y acompañar cada proceso con más seguridad, confianza y criterio profesional.\n\nPor eso, muchos alumnos nos dicen que esta formación no sustituyó lo que ya sabían, sino que les ayudó a comprenderlo, integrarlo y llevarlo a un nivel mucho más profundo.\n\nNuestro objetivo no es enseñarte una técnica más, sino ayudarte a convertirte en el terapeuta que sabes que puedes llegar a ser." },
      { q: "¿Por qué esta formación es diferente?", a: "Porque no solo aprenderás una técnica. Aprenderás a comprender lo que sucede en cada sesión para acompañar procesos de transformación con seguridad, confianza y criterio profesional.\n\nEsta certificación integra Activación Kundalini, neurociencia, sistema nervioso, respiración, liberación somática, sonoterapia y facilitación terapéutica en una metodología única que une ciencia y espiritualidad de forma coherente y práctica.\n\nNo nos limitamos a enseñarte qué hacer. Te enseñamos por qué ocurre cada proceso, cómo sostenerlo de forma segura y cómo adaptarte a las necesidades de cada persona, para que puedas facilitar sesiones con la tranquilidad de saber qué está sucediendo en cada momento.\n\nPorque cuando comprendes el cuerpo, el sistema nervioso y la energía como un mismo lenguaje, dejas de actuar desde la intuición para acompañar desde la presencia, el conocimiento y la confianza." },
      { q: "¿Aprenderé a sostener emociones intensas?", a: "Sí. De hecho, esa es una de las habilidades más importantes que desarrollarás durante la certificación.\n\nAprenderás a leer el lenguaje del cuerpo y del sistema nervioso, reconocer la ventana de tolerancia de cada persona y comprender qué está ocurriendo realmente durante un proceso de liberación emocional o energética.\n\nSabrás cómo actuar cuando aparezcan emociones intensas, bloqueos, catarsis o estados de gran sensibilidad, acompañando cada experiencia con seguridad, presencia y criterio profesional, sin improvisar ni sentirte desbordado.\n\nPorque un buen terapeuta no es quien evita que aparezcan las emociones, sino quien sabe sostenerlas e integrarlas de forma segura, ayudando a que la experiencia se convierta en una verdadera transformación y no en un momento aislado." },
      { q: "¿Podré facilitar sesiones después de la certificación?", a: "Sí. Toda la formación está diseñada para que finalices la certificación con la preparación, la seguridad y la confianza necesarias para comenzar a facilitar sesiones de Activación Kundalini tanto individuales como grupales.\n\nAprenderás a preparar el espacio, conducir cada fase de la sesión, sostener los diferentes procesos que puedan surgir, integrar la experiencia y acompañar a cada persona con un enfoque profesional, seguro y respetuoso.\n\nDurante la formación practicarás con casos reales, recibirás supervisión directa y desarrollarás la experiencia necesaria para sentirte preparado antes de comenzar a trabajar con tus propios clientes.\n\nNuestro objetivo no es solo que obtengas una certificación. Es que salgas con la confianza de poder abrir tu consulta, incorporar esta metodología a tu profesión o comenzar a facilitar sesiones desde el primer día con el respaldo de un método sólido y una escuela que seguirá acompañándote incluso después de certificarte." },
      { q: "¿Cómo funciona la parte presencial?", a: "La certificación culmina con 4 días de formación presencial intensiva, donde transformarás todo el conocimiento adquirido online en experiencia práctica real.\n\nPracticarás activaciones con compañeros, facilitarás sesiones bajo supervisión, aprenderás a gestionar los distintos procesos que pueden surgir durante una sesión y recibirás correcciones y acompañamiento continuo por parte de Susana Dakini y su equipo.\n\nEs el espacio donde desarrollarás la confianza, la presencia y la seguridad necesarias para acompañar procesos profundos de transformación con criterio profesional.\n\nPorque un gran terapeuta no se forma solo estudiando. Se forma practicando, siendo acompañado y aprendiendo a sostener experiencias reales." },
      { q: "¿Existe acompañamiento después de la certificación?", a: "Sí. De hecho, para nosotros la certificación es solo el comienzo.\n\nAl convertirte en alumno de Escuela Metta, pasas a formar parte de una comunidad privada de terapeutas donde seguirás creciendo, compartiendo experiencias y resolviendo dudas junto a otros profesionales.\n\nAdemás, durante los 2 años posteriores a tu certificación, podrás repetir la formación de forma gratuita para integrar mejor el método, actualizar tus conocimientos y seguir perfeccionando tu práctica.\n\nY como parte de tu formación, también tendrás incluido durante 1 año el acceso gratuito a Spiritual Mastery, nuestra membresía exclusiva, donde cada mes participarás en masterclasses especiales impartidas por Susana Dakini y otros profesores invitados, con nuevas herramientas, prácticas, casos reales y contenidos de desarrollo profesional y personal.\n\nPorque nuestro compromiso no es solo enseñarte una técnica, sino acompañarte en tu evolución para que sigas creciendo mucho después de obtener tu certificación." },
    ],
  },
  footer: {
    tagline: "Ciencia + Kundalini + Cuerpo + Consciencia.",
    school: "Escuela Metta",
    rights: "Todos los derechos reservados.",
    cta: "Hablar con Escuela Metta",
  },
};

const en = {
  langName: "EN",
  nav: {
    links: [
      { id: "metodo", label: "The Method" },
      { id: "aprender", label: "What you'll learn" },
      { id: "susana", label: "About us" },
      { id: "inversion", label: "Investment" },
      { id: "ediciones", label: "Editions" },
      { id: "testimonios", label: "Testimonials" },
      { id: "faq", label: "FAQ" },
    ],
    cta: "I want to apply for a spot",
  },
  ctas: {
    info: "Request information",
    call: "Book your admission call",
    discover: "Discover if this training is for you",
    talk: "Talk to Escuela Metta",
  },
  sticky: "Book your admission call",
  hero: {
    badge: "Professional Training in Kundalini METTA® Activation",
    title: "Learn to guide the awakening of Kundalini energy safely.",
    subtitle:
      "Become a Certified Therapist with the only method that unites science and spirituality to understand what really happens during a Kundalini awakening and to hold deep processes with safety, confidence and professional judgment.",
    bullets: [
      "Live your own transformation first.",
      "Learn a methodology that delivers results.",
      "Create high-value individual and group sessions.",
      "Turn your gift into your profession.",
      "Overcome impostor syndrome and procrastination.",
    ],
    cta: "Book an interview",
  },
  video: {
    overline: "A message from the founder",
    title: "The video I wish I'd seen before training",
    videoId: "1206521365",
    thumb: "https://customer-assets.emergentagent.com/job_mettasomatic-pro/artifacts/9h1ze9bc_Dise%C3%B1o%20sin%20t%C3%ADtulo%20%2859%29.png",
    subtitle:
      "What no school explained to me about how to guide Kundalini awakenings safely.",
    discoverTitle: "By the time you finish this training:",
    discover: [
      "You'll be ready to facilitate individual and group sessions with safety and confidence from day one.",
      "You'll learn to hold deep transformation processes without improvising or absorbing the pain of the people you accompany.",
      "You'll master clear protocols to know which tool to use at each moment according to each client's needs.",
      "You'll learn to create professional Kundalini Activation playlists and understand how to use music to guide each phase of a session.",
      "You'll get access to Susana Dakini's exclusive playlist library and learn to use shamanic instruments to enhance the therapeutic experience.",
      "You'll receive guidance to build your personal brand, attract your first clients and turn your calling into a profession.",
      "You'll become part of an international community of facilitators that will keep supporting you and accompanying your professional growth after certification.",
    ],
    discoverClose:
      "You won't just learn a technique. You'll leave with a complete system: protocols, playlists, instruments, resources and a methodology ready to accompany deep transformations from day one.",
    caption: "Susana Dakini, founder and trainer of Kundalini Metta",
    play: "Play message",
    placeholder: "Susana Dakini's video — ready to embed (YouTube / Vimeo / MP4)",
  },
  pain: {
    overline: "The calling",
    title:
      "You were made to believe that your sensitivity and spiritual connection were the problem. All you needed was a method that turned your intuition into professional judgment.",
    points: [
      "You know you have a special sensitivity. You perceive things others don't. But you still don't know how to turn that gift into a safe, professional therapeutic tool.",
      "You've been training for years. You've taken courses, read books and lived deep experiences. And yet, you feel you're still missing «something» to accompany others with real confidence.",
      "You see other therapists guiding sessions, creating groups and living from what they love. And deep down you think: «I know I could do that too».",
      "But then impostor syndrome appears: «What if I don't know what to do during a session?», «What if nothing happens?», «What if too much happens?», «What if I cause harm?», «What if I'm still not enough?».",
      "You don't doubt your calling. You doubt that you haven't yet found the method that teaches you to guide Kundalini awakenings safely, understand each process and feel ready to transform lives with confidence.",
    ],
    quote:
      "You were made to believe that your sensitivity and spiritual connection were the problem. All you needed was a method that turned your intuition into professional judgment.",
  },
  trained: {
    overline: "For those already trained",
    title: "Knowing how to activate energy doesn't make you a therapist. Understanding what happens during a Kundalini awakening does.",
    intro:
      "You've learned a technique. You've facilitated sessions. Maybe you already accompany people. But, deep down, there are still moments when you ask yourself…",
    tags: ["Kundalini Activation", "Innerdance", "Shaktipat", "Energy therapies"],
    questions: [
      {
        scenario: "The person starts to tremble…",
        question:
          "How do you know if it's a nervous-system discharge, an emotional release or a Kundalini awakening process?",
      },
      {
        scenario: "The client bursts into tears.",
        question: "Do you intervene… or let the process continue?",
      },
      {
        scenario: "After the session everything seems to have changed…",
        question:
          "How do you make sure that transformation doesn't vanish three days later?",
        note: "This is where integration comes in.",
      },
      {
        scenario: "Your client asks you: «What just happened to me?»",
        question:
          "Could you explain it from science… and also from consciousness?",
      },
    ],
    quote: {
      lead: "When you don't understand what's happening…",
      lines: [
        "You improvise.",
        "You hesitate.",
        "You lose confidence.",
        "Your clients sense it.",
        "And you end up relying on intuition instead of a method, and you feel lost in the middle of the session because you don't know how to unite intuition and method.",
      ],
      close:
        "Not because you're a bad therapist. But because no one taught you to interpret what happens during a true Kundalini awakening.",
    },
  },
  bridge: {
    overline: "The mistake almost every school makes",
    title:
      "A therapist's quality isn't measured by the intensity of the experience they trigger.",
    subtitle:
      "It's measured by their ability to hold, integrate and consolidate a transformation that lasts long after the session ends.",
    paragraphs: [
      "Most schools put all their attention on triggering an experience.",
      "And the truth is that quality is measured by the results their clients achieve weeks and months after the sessions.",
      "We put our attention on making that experience transform a life.",
      "Because an intense experience can move you for a few hours. Even for a few days. But if the therapist doesn't know how to integrate it… the person will think the same way again, feel the same way, and repeat the same patterns they'd spent years trying to change.",
      "That's why, at KUNDALINI METTA®, you won't only learn to guide Kundalini awakenings safely. You'll learn the most important part of the whole process: how to turn an experience into a permanent transformation.",
    ],
    midHeading: "This is where a true therapist is born.",
    paragraphs2: [
      "During integration is when the brain creates new connections. When the body stops reacting from old patterns. When emotions find a new way to express themselves. When limiting beliefs begin to lose their grip. And when the person stops surviving… to start living from a completely different place.",
      "That's why our students don't create impressive sessions. They create processes that keep transforming their clients' lives long after the session has ended.",
      "That's the reason our method is different.",
      "Most schools teach you how to open a session. We teach you what to do before, during and after.",
      "Because great transformations never depend on an isolated experience. They depend on how you hold the entire process.",
      "And that process is what makes your clients:",
    ],
    bullets: [
      "Come back.",
      "Recommend your work.",
      "Trust you more.",
      "And live changes that truly last.",
    ],
  },
  method: {
    overline: "",
    title:
      "The system that teaches you to guide Kundalini awakenings safely, deeply and in a way that can be integrated.",
    intro:
      "You won't only learn «what to do» in a session. You'll learn to understand what is happening, how to hold it and how to integrate it, so the experience doesn't stay as something intense… but becomes a real transformation.",
    pillars: [
      {
        n: "01",
        title: "Kundalini METTA® Activation",
        desc: [
          "You'll learn to open, hold and close individual and group sessions with a clear, safe and professional structure.",
          "It's not about «triggering energy». It's about knowing how to guide a process where the person can reconnect with their body, their intuition, their essence and their purpose without losing safety or direction.",
        ],
      },
      {
        n: "02",
        title: "The science of awakening",
        desc: [
          "You'll understand what happens during a session at the level of the nervous system, the physical body, emotions, biochemistry and states of consciousness.",
          "Because when you know how to explain what's happening, you stop improvising. And you start to accompany with judgment, presence and professional confidence.",
        ],
      },
      {
        n: "03",
        title: "Integration of the experience",
        desc: [
          "This is the part most schools forget.",
          "An intense experience can move you. But a well-integrated experience can change a life.",
          "You'll learn to hold the after of the session so the client can turn what they lived into clarity, decisions, release of patterns and real changes in their daily life.",
        ],
      },
      {
        n: "04",
        title: "Deep healing tools",
        desc: ["The training includes specific techniques to create real transformation processes:"],
        items: [
          "Specific Breathwork for Kundalini Activation, to prepare the body and deepen the experience.",
          "Quantum healing for the physical, emotional and spiritual body, to work on different layers of the process.",
          "Pericardium Release Express, to unblock the heart center and encourage emotional opening.",
          "Reprogramming of limiting beliefs, to sustain the transformation after the session and prevent the person from returning to the same pattern.",
        ],
      },
      {
        n: "05",
        title: "Professional facilitation",
        desc: [
          "You'll learn how to open a session, read the process, intervene when necessary, hold deep moments and close safely.",
          "You'll also learn to explain your work with clarity so your clients understand the value of what you do and trust your guidance more.",
        ],
      },
      {
        n: "06",
        title: "Expansion of your professional practice",
        desc: [
          "If you're already a therapist, this training doesn't come to replace what you do. It comes to elevate it.",
          "You'll be able to create premium individual sessions, VIP processes, group sessions, workshops, retreats and high-value experiences that increase client retention and set your work apart in a market saturated with techniques.",
        ],
      },
    ],
    closing:
      "You won't leave with one more technique. You'll leave with a complete system to accompany Kundalini awakenings with safety, science, spirituality, integration and professional vision.",
  },
  learn: {
    overline: "Curriculum",
    title: "What you'll learn",
    items: [
      "Individual and group Kundalini activation",
      "Holding the energy field",
      "Chakra and meridian system",
      "Neuroscience of activation",
      "Brainwaves and sound",
      "Professional playlist creation",
      "Breathwork to activate and regulate",
      "Pericardium release",
      "Energetic protection for the therapist",
      "Language of light and voice",
      "Session management",
      "Marketing for therapists",
    ],
  },
  experience: {
    overline: "The training experience",
    title: "It's not a training you study. It's a transformation you go through.",
    formats: [
      { tag: "Phase 1", label: "Online Level", desc: "Learn self-activation of Kundalini energy, chakra unblocking, intuition expansion and the scientific and energetic foundations that will prepare you to become a therapist." },
      { tag: "Phase 2", label: "4 days of intensive in-person training", desc: "Turn knowledge into experience. Practice with real cases, facilitate sessions under the supervision of Susana Dakini and her team, receive personalized feedback and develop the security, confidence and skills needed to guide deep transformation processes with professional judgment." },
    ],
    note: "Certified training · Kundalini Metta Activation",
  },
  testimonials: {
    overline: "",
    title: "Real stories of transformation",
    subtitle:
      "Before the fear. After the method. What happens when an experience becomes a profession.",
    people: [
      { name: "Almudena", role: "Psychologist", videoId: "1206449879", thumb: "https://i.vimeocdn.com/video/2175299296-773b1ea0b96444ff0e5923615b87fa0ae89373e32bf477bf45e27e1b93f4372d-d_960" },
      { name: "Cristina", role: "Psychologist", videoId: "1206448715", thumb: "https://i.vimeocdn.com/video/2175293373-d045084da7e6df3c1a85d0f54d2e671b67a8f5bafb62779458c01878ac6fae09-d_960" },
      { name: "Ruth", role: "Therapist", videoId: "1206478560", thumb: "https://i.vimeocdn.com/video/2175335773-f534cfad3d2ba1f6a3d36f730861b21268a869e9ac8aa94dd01b6c4b933de6d2-d_960" },
      { name: "Diana", role: "Therapist", videoId: "1206483810", thumb: "https://i.vimeocdn.com/video/2175338297-3eba4de8c82f7ad3f1c2898eaeac6105dda2623edab9350cb084864bd5077833-d_960" },
      { name: "Paula", role: "Engineer & Coach", videoId: "1206482585", thumb: "https://i.vimeocdn.com/video/2175337340-8fceb2079c06da2ab65cec4be0777b28003478a85a139463228f6b59f5b2fd36-d_960" },
      { name: "Diana", role: "Yoga teacher", videoId: "1206484595", thumb: "https://i.vimeocdn.com/video/2175339256-fae0da030004180bec19a322c28a6b5c372b34176b8437c0b264f7ae19715bab-d_960" },
      { name: "María", role: "Teacher", videoId: "1206485797", thumb: "https://i.vimeocdn.com/video/2175355265-4357885229c65888797d2d034ae93d9d20411be205dc7be67fb3e61496b85cb8-d_960" },
    ],
  },
  about: {
    overline: "About me",
    name: "Susana Dakini",
    role: "Founder of Escuela Metta",
    quote:
      "You'll never be able to build a life more abundant than the level of worthiness your own nervous system is able to hold.",
    bio1: [
      "After experiencing several spontaneous Kundalini awakenings, I decided to train with Pi Villaraza and other teachers.",
      "I didn't learn it in a book or a master's degree. I learned it trying to rebuild my own life.",
      "My story began as a child. I spent months hospitalized with severe respiratory problems and suffered three cardiorespiratory arrests. Soon after, I lived through nine years of bullying. Without knowing it, my nervous system learned far too early to live in survival mode.",
      "In time came anxiety, panic attacks and a question that would change my destiny:",
    ],
    midQuote:
      "Why, if my mind knew I was safe, did my body keep reacting as if the danger had never ended?",
    bio2: [
      "Looking for answers, I studied Pharmacy. I wanted to understand the human body and relieve suffering. But I soon realized I was learning to treat illnesses… without truly understanding the person behind them.",
      "So I made a decision that transformed my life: to leave that path and dedicate myself to researching the connection between science, body and consciousness.",
      "Over the last 15 years I've invested more than €60,000 in training, specializing in trauma, neuroscience, Breathwork, Mindfulness, Transpersonal Psychology, nervous-system regulation and expanded states of consciousness, with a single purpose: to understand how deep, lasting transformation happens.",
      "That journey gave rise to Escuela Metta and to three original methodologies that have trained hundreds of therapists and facilitators, integrating science, breathing, trauma, somatic work and consciousness on a single path of transformation.",
    ],
    methods: [
      { name: "METTABREATH®", desc: "for training Breathwork instructors, nervous-system regulation and deep transformation." },
      { name: "KUNDALINI METTA®", desc: "my Kundalini Activation methodology from a neurophysiological, somatic and trauma-informed perspective, where energy is understood and held from the integration of science and consciousness." },
      { name: "SOMAFLOW®", desc: "a somatic trauma-release method that integrates body work, the fascial system, nervous-system regulation and the main international currents of somatic therapy." },
    ],
    bio3: [
      "Since 2012 I've had the privilege of training more than 600 therapists and facilitators, and accompanying thousands of people through some of the most important moments of their lives.",
      "But my greatest achievement has never been the certifications or the number of students. It's seeing how people who once arrived feeling broken discover that their wounds can become the very place from which they best accompany others.",
      "Because that has also been my story. And that remains the essence of METTABREATH®.",
    ],
    mission:
      "Not to train only Breathwork instructors. To train therapists and facilitators whose own transformation becomes the greatest tool with which they'll accompany the transformation of others.",
    missionClose:
      "Today my mission is to train a new generation of professionals who don't just master a technique, but who become the safe place from which other people can transform their lives.",
    stats: [
      { n: "2012", l: "since" },
      { n: "+600", l: "certified graduates" },
      { n: "+3500", l: "sessions facilitated" },
    ],
    creatorLabel: "Creator of",
    creator: ["METTABREATH®", "KUNDALINI METTA®", "SOMAFLOW®"],
    formationsLabel: "Trained in",
    formations: ["Trauma", "Neuroscience", "Breathwork", "Mindfulness", "Transpersonal Psychology", "Somatics", "Expanded states"],
  },
  faculty: {
    overline: "Teaching team",
    title: "Alongside Susana Dakini and Viveka Romero",
    subtitle:
      "A training supported by a multidisciplinary team of teachers and specialists.",
    people: [
      { name: "Viveka Romero", role: "Escuela Metta trainer, Non-Duality meditation teacher and writer.", img: "/teachers/viveka.jpg" },
      { name: "Raúl Bautista", role: "Music producer and DJ, trainer in playlist creation and sound.", img: "/teachers/raul.jpg" },
      { name: "Damaris Sánchez", role: "Phonoenergetics and shamanic drum teacher, chanting and sound & energy activation.", img: "/teachers/damaris.jpg" },
      { name: "Rebeca Muru", role: "Somaflow trainer, specialist in trauma and somatic yoga.", img: "/teachers/rebeca.jpg" },
    ],
  },
  bonus: {
    overline: "Included in the training",
    title: "You also receive",
    items: [
      { t: "Holistic Business Plan", d: "Learn to create your first sales funnel, attract your first clients and turn your passion into a profession with a clear and sustainable strategy." },
      { t: "Photo and video session", d: "Get exclusive content for your social media, website and personal brand from day one." },
      { t: "Professional playlist creation", d: "Learn to design playlists that enhance every phase of the session and receive Susana Dakini's exclusive playlist library, ready to use from your very first session." },
      { t: "Escuela Metta brand support", d: "Includes an Official Therapist Directory, social media promotion, 1 year of Spiritual Mastery and access to an exclusive community to keep growing." },
      { t: "Private student community", d: "Practice with fellow students, share experiences and resolve questions in our private WhatsApp group. Because growing with support always accelerates your evolution as a therapist." },
      { t: "Repeat the training for 2 years", d: "Relive it whenever you need to." },
      { t: "BioWell technology", d: "Energetic analysis and real measurement." },
    ],
  },
  editions: {
    overline: "Editions calendar 2026",
    title: "Upcoming editions",
    subtitle:
      "3 months of online training + 4 in-person days. Choose the city you want to attend. Small groups: spots are assigned after the assessment interview.",
    note: "* Each edition combines 3 months online with 4 in-person days (a retreat in the marked case).",
    cta: "Reserve my spot",
    list: [
      {
        date: "July 2026",
        name: "In-person retreat · 21–26",
        location: "Guadalajara · Spain",
        format: "Online + in-person retreat",
        status: "Completed",
        tone: "done",
      },
      {
        date: "September 2026",
        name: "In-person · 24–27",
        location: "Barcelona · Spain",
        format: "3 months online + 4 in-person days",
        status: "Last spots",
        tone: "few",
      },
      {
        date: "October 2026",
        name: "In-person · 8–11",
        location: "Madrid · Spain",
        format: "3 months online + 4 in-person days",
        status: "Enrollment open",
        tone: "open",
      },
      {
        date: "November 2026",
        name: "In-person · 19–22",
        location: "Mallorca · Spain",
        format: "3 months online + 4 in-person days",
        status: "Enrollment open",
        tone: "open",
      },
      {
        date: "December 2026",
        name: "In-person · 3–6",
        location: "Málaga · Spain",
        format: "3 months online + 4 in-person days",
        status: "Enrollment open",
        tone: "open",
      },
    ],
  },
  pricing: {
    overline: "Investment & spot reservation",
    title: "Your transformation as a therapist begins with a decision.",
    intro: [
      "You're investing in a methodology you'll be able to use throughout your entire professional life to guide Kundalini awakenings safely, create complete transformation processes and build a business based on the real impact you create for your clients.",
    ],
    consequences: ["Every session.", "Every VIP process.", "Every group experience.", "Every retreat.", "Every referral."],
    consequencesNote:
      "Will be a direct consequence of the skills you'll develop during this certification.",
    plansLabel: "Choose how to join",
    plans: [
      {
        name: "Training + VIP Mentorship",
        price: "€2,490",
        featured: false,
        desc: "The most complete and exclusive level: personal, direct guidance from Susana Dakini to accelerate your path as a therapist.",
        pointsLabel: "Includes",
        points: [
          "9 individual mentorship sessions with Susana Dakini to personally support your evolution as a therapist and help you integrate everything you learn.",
          "1 in-person healing session with Susana Dakini, designed to deepen your own process before guiding others.",
          "12 months of follow-up, so you never feel alone as you start facilitating your first sessions.",
          "Personalized audit of your business, where we'll review your strategy to help you turn your passion into a profitable profession.",
          "Design of your professional website as a Kundalini Activation therapist, ready to start attracting clients.",
          "Escuela Metta's exclusive energetic protection device to support you during your sessions with greater safety and confidence.",
          "🎁 Gift: Professional 128 Hz Therapeutic Tuning Fork, a vibrational therapy tool to enrich your sessions and expand your resources as a therapist.",
          "🎁 Gift: Connection & grounding essential oil kit.",
          "Priority support, with preferred attention to answer your questions and support you whenever you need it.",
        ],
        cta: "I want to book my interview",
      },
      {
        name: "Preferred Access",
        badge: "Recommended",
        seal: "Limited spots",
        price: "€1,222",
        priceNote: "Only for 72 hours",
        featured: true,
        desc: "The smartest way to join the KUNDALINI METTA® Certification.",
        points: [
          "Reserve your spot today with just €111.",
          "Your preferred access will stay active for the next 72 hours.",
          "The rest (€1,111) can be paid in a single payment or split into up to 4 interest-free installments.",
          "Once those 72 hours have passed, this option will no longer be available.",
        ],
        cta: "I want to book my interview",
      },
      {
        name: "Flexible Access",
        price: "€1,490",
        featured: false,
        desc: "For those who prefer to split the investment into several payments and start their training now.",
        pointsLabel: "Payment options",
        points: [
          "3 installments of €496",
          "6 installments of €259",
          "8 installments of €196",
        ],
        cta: "I want to book my interview",
      },
    ],
    whyTitle: "Why do we keep this access window open for only 72 hours?",
    why: [
      "Because we're not looking for people who spend months hesitating.",
      "We're looking for those who feel the calling, make a decision and commit to becoming the therapist they know they can be.",
      "It's not a promotion. It's a way to reward commitment and make access easier for those ready to take the next step.",
      "What truly matters isn't how much this training costs. It's everything you'll be able to create thanks to it.",
    ],
    benefits: [
      "A methodology you'll use throughout your entire professional career.",
      "The ability to create premium individual sessions and VIP processes.",
      "The possibility to facilitate group experiences and high-value retreats.",
      "Clients who return because they live real transformations.",
      "Constant referrals thanks to the impact of your work.",
      "A profession aligned with your purpose and a business built on results, not promises.",
    ],
    closing:
      "The real question isn't whether you can afford this training. The real question is how much longer you want to keep going without becoming the therapist you know you can be.",
    closingCta: "I want to book my interview",
  },
  mbPricing: {
    overline: "Investment",
    title: "Choose how you want to access the METTABREATH® International Certification",
    subtitle1:
      "All options include exactly the same training, the same official METTABREATH® certification, full campus access, the private community and all the support during your process.",
    subtitle2: "The only difference is how you choose to make your investment.",
    plans: [
      {
        tone: "elite",
        badge: "Elite Experience",
        name: "Inner Circle METTABREATH®",
        price: "€2,490",
        desc: "The most exclusive experience for those who want fully personalized guidance to accelerate their professional development.",
        points: [
          "Full access to the METTABREATH® International Certification",
          "Private 1:1 mentorship with Susana Dakini",
          "Personalized review of your first sessions",
          "Individual feedback on your evolution as an instructor",
          "Priority support",
          "Personalized strategy to launch your first METTABREATH® experiences",
        ],
        cta: "I want to join the Inner Circle",
        featured: false,
      },
      {
        tone: "star",
        badge: "Most chosen option",
        name: "Preferred Access",
        price: "€1,490",
        desc: "The best balance between investment and value.",
        points: [
          "Full access to the METTABREATH® International Certification",
          "Reserve your spot today with just €199",
          "The €199 is fully deducted from the final price",
          "You save €300 compared to Flexible Access",
          "You keep this special price for the next 72 hours",
          "Exactly the same training, certification and support",
        ],
        cta: "I want to secure my spot",
        featured: true,
      },
      {
        tone: "flex",
        badge: "Flexible Access",
        name: "Installment Payment",
        price: "€1,790",
        desc: "The same certification. More flexibility to make your investment.",
        text: "Reserve your spot today with just €199 and choose how you prefer to complete the rest of your investment.",
        installments: [
          { n: "3 installments", amount: "€530/mo" },
          { n: "6 installments", amount: "€265/mo" },
          { n: "8 installments", amount: "€199/mo" },
        ],
        cta: "I want flexible payment access",
        featured: false,
      },
    ],
    mostTitle: "Which one do most of our students choose?",
    most: [
      "If you can make the one-time payment, Preferred Access is the option that offers the most value.",
      "You get exactly the same certification, the same support and all the program's benefits, saving €300 compared to Flexible Access.",
      "That's why it's the option chosen by the vast majority of our students.",
    ],
    guarantee: [
      "Same official certification",
      "Same content",
      "Same bonuses",
      "Same support",
      "Same community",
      "Same transformation experience",
    ],
    guaranteeNote: "The only difference is the way you choose to make your investment.",
  },
  application: {
    overline: "The next step",
    title: "Do you feel this is your next step?",
    text:
      "We don't aim to train facilitators who only repeat a technique. We train therapists capable of understanding, holding and accompanying real processes of transformation.",
    cta: "Book a call with Escuela Metta",
  },
  faq: {
    overline: "Frequent questions",
    title: "Frequently asked questions",
    items: [
      { q: "Do I need previous experience?", a: "No. You don't need experience as a therapist or to have completed other trainings to access the certification.\n\nThe program is designed to guide you step by step, building from the ground up a solid understanding of the nervous system, neurophysiology, energy, breathwork and the facilitation of transformation processes, so you can progress with safety and confidence.\n\nAt the same time, if you're already a therapist, coach, yoga teacher, health professional or accompany people in other fields, you'll learn to integrate this methodology into your professional practice, expanding your resources and raising the quality of your work.\n\nIt doesn't matter where you start from. What matters is that, by the end of the certification, you have the knowledge, practice and confidence needed to facilitate sessions with judgment, safety and professionalism." },
      { q: "Can I train if I've already studied at another school?", a: "Yes. In fact, many of our students arrive after training in other methodologies.\n\nEach school brings a different perspective, and that prior experience usually becomes a great advantage during the certification.\n\nAt Escuela Metta you'll deepen your understanding of the nervous system, neurophysiology, emotional integration and energy, to understand more clearly what happens during a session and to accompany each process with greater safety, confidence and professional judgment.\n\nThat's why many students tell us this training didn't replace what they already knew, but helped them understand it, integrate it and take it to a much deeper level.\n\nOur goal isn't to teach you one more technique, but to help you become the therapist you know you can be." },
      { q: "Why is this training different?", a: "Because you won't just learn a technique. You'll learn to understand what happens in each session so you can guide transformation processes with safety, confidence and professional judgment.\n\nThis certification integrates Kundalini Activation, neuroscience, the nervous system, breathwork, somatic release, sound therapy and therapeutic facilitation into a unique methodology that unites science and spirituality in a coherent and practical way.\n\nWe don't just teach you what to do. We teach you why each process happens, how to hold it safely and how to adapt to each person's needs, so you can facilitate sessions with the peace of mind of knowing what's happening at every moment.\n\nBecause when you understand the body, the nervous system and energy as one same language, you stop acting from intuition and start accompanying from presence, knowledge and confidence." },
      { q: "Will I learn to hold intense emotions?", a: "Yes. In fact, that's one of the most important skills you'll develop during the certification.\n\nYou'll learn to read the language of the body and the nervous system, recognize each person's window of tolerance and understand what's really happening during an emotional or energetic release process.\n\nYou'll know how to act when intense emotions, blocks, catharsis or states of great sensitivity arise, accompanying each experience with safety, presence and professional judgment, without improvising or feeling overwhelmed.\n\nBecause a good therapist isn't the one who prevents emotions from arising, but the one who knows how to hold and integrate them safely, helping the experience become a true transformation and not an isolated moment." },
      { q: "Will I be able to facilitate sessions after certification?", a: "Yes. The whole training is designed so you finish the certification with the preparation, security and confidence needed to start facilitating Kundalini Activation sessions, both individual and group.\n\nYou'll learn to prepare the space, guide each phase of the session, hold the different processes that may arise, integrate the experience and accompany each person with a professional, safe and respectful approach.\n\nDuring the training you'll practice with real cases, receive direct supervision and develop the experience needed to feel ready before starting to work with your own clients.\n\nOur goal isn't just for you to obtain a certification. It's for you to leave with the confidence to open your practice, integrate this methodology into your profession or start facilitating sessions from day one, backed by a solid method and a school that will keep supporting you even after you're certified." },
      { q: "How does the in-person part work?", a: "The certification culminates with 4 days of intensive in-person training, where you'll transform all the knowledge gained online into real hands-on experience.\n\nYou'll practice activations with peers, facilitate sessions under supervision, learn to manage the different processes that can arise during a session, and receive continuous corrections and support from Susana Dakini and her team.\n\nIt's the space where you'll develop the confidence, presence and security needed to guide deep transformation processes with professional judgment.\n\nBecause a great therapist isn't shaped by studying alone. They're shaped by practicing, being supported and learning to hold real experiences." },
      { q: "Is there support after certification?", a: "Yes. In fact, for us certification is only the beginning.\n\nWhen you become an Escuela Metta student, you join a private community of therapists where you'll keep growing, sharing experiences and resolving questions alongside other professionals.\n\nIn addition, during the 2 years after your certification, you'll be able to repeat the training for free to better integrate the method, update your knowledge and keep refining your practice.\n\nAnd as part of your training, you'll also get free access for 1 year to Spiritual Mastery, our exclusive membership, where each month you'll take part in special masterclasses led by Susana Dakini and other guest teachers, with new tools, practices, real cases and professional and personal development content.\n\nBecause our commitment isn't just to teach you a technique, but to support your evolution so you keep growing long after obtaining your certification." },
    ],
  },
  footer: {
    tagline: "Science + Kundalini + Body + Consciousness.",
    school: "Escuela Metta",
    rights: "All rights reserved.",
    cta: "Talk to Escuela Metta",
  },
};

export const content = { es, en };
